import Vue from "vue";
import VueSVGIcon from "vue-svgicon";

// import VuePlausible from 'vue-plausible/lib/cjs/vue-plugin';
import VuePlausible from "./plugins/plausible";

import PaltaCore from "@palta-ui/core";

import PaltaButton from "@palta-ui/button";
import PaltaCheck from "@palta-ui/check";
import PaltaCombo from "@palta-ui/combo";
import PaltaDocument from "@palta-ui/document";
import PaltaField from "@palta-ui/field";
import PaltaForm from "@palta-ui/form";
import PaltaIcon from "@palta-ui/icon";
import PaltaImage from "@palta-ui/image";
import PaltaLabel from "@palta-ui/label";
import PaltaLink from "@palta-ui/link";
import PaltaLoader from "@palta-ui/loader";
import PaltaNotifications from "@palta-ui/notifications";
import PaltaPassword from "@palta-ui/password";
import PaltaSection from "@palta-ui/section";
import PaltaSign from "@palta-ui/sign";
import PaltaText from "@palta-ui/text";
import PaltaTitle from "@palta-ui/title";
import PaltaView from "@palta-ui/view";
import PaltaWorkspace from "@palta-ui/workspace";

import router from "./router";
import App from "./App.vue";

import CountriesCombo from "./components/combos/countries_combo";
import LanguagesCombo from "./components/combos/languages_combo";
import TimezonesCombo from "./components/combos/timezones_combo";
import PlansCombo from "./components/combos/plans_combo";

import "@palta-ui/core/src/stylus/main.styl";
import "@palta-ui/icon/src/icons";

// document.documentElement.setAttribute('data-theme', 'dark');

Vue.use(VueSVGIcon);

Vue.use(VuePlausible, {
  // init: {
  domain: "envone.com",
  // apiHost: 'https://site.com',
  trackLocalhost: true,
  enableAutoPageviews: true,
  hashMode: true,
  // },
  // partytown: true,
});

Vue.use(PaltaCore, {
  scopes: {
    locale: "es",
  },
});

Vue.use(PaltaButton);
Vue.use(PaltaCheck);
Vue.use(PaltaCombo);
Vue.use(PaltaDocument);
Vue.use(PaltaField);
Vue.use(PaltaForm);
Vue.use(PaltaIcon);
Vue.use(PaltaImage);
Vue.use(PaltaLabel);
Vue.use(PaltaLink);
Vue.use(PaltaLoader);
Vue.use(PaltaNotifications);
Vue.use(PaltaPassword);
Vue.use(PaltaSection);
Vue.use(PaltaSign);
Vue.use(PaltaText);
Vue.use(PaltaTitle);
Vue.use(PaltaView);
Vue.use(PaltaWorkspace);

Vue.config.productionTip = false;

Vue.mixin({
  components: {
    CountriesCombo,
    LanguagesCombo,
    TimezonesCombo,
    PlansCombo,
  },
});

new Vue({
  router,
  i18n: {
    messages: [],
    locale: "en",
  },
  render: (h) => h(App),
}).$mount("#app");
